module.exports = __webpack_public_path__ + "static/media/order-promise-broken.5ab8a45a.svg";